<template>
  <div class="approval-process tb" v-if="funcView.process_list">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item>
          <el-button v-if="funcView.approval_process_add" type="primary" icon="el-icon-plus" @click="add">{{ funcView.approval_process_add }}</el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right; margin-right: 0">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <!-- 搜索项 -->
        <el-form-item style="float: right">
          <search-input v-model="formSearch.workflowName" :placeholder="$t('base_approvalProcess.liu_cheng_ming_cheng')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-bd">
      <custom-table tableCode="approval_process_list" height="100%" :data="tableList" :index="true" @filter="filterChange" @sort="sortChange" @column="setColumn">
        <!-- <template v-slot:workflowType="scope">
          <work-flow-type-text
            :workflowType="scope.row.workflowType"
          ></work-flow-type-text>
        </template> -->
        <el-table-column :label="$t('Common.com_handle')" min-width="120" fixed="right">
          <template slot-scope="scope">
            <span></span>
            <el-button v-if="scope.row.state && funcView.approval_process_close" type="text" size="mini" @click="close(scope.row)">{{ funcView.approval_process_close }}</el-button>
            <el-button v-if="!scope.row.state && funcView.approval_process_open" type="text" size="mini" @click="open(scope.row)">{{ funcView.approval_process_open }}</el-button>
            <el-button v-if="funcView.approval_process_edit" type="text" size="mini" @click="edit(scope.row)">{{ funcView.approval_process_edit }}</el-button>
          </template>
        </el-table-column>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
  </div>
</template>

<script>
/** 审批流程管理 */

import apis from '@/utils/apis';
// import workFlowTypeText from './children/work_flow_type_text';

export default {
  name: 'approvalProcess',
  // components: { workFlowTypeText },
  data() {
    return {
      tableList: [],
      formSearch: {
        workflowName: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
      },
      totalRows: 0,
    };
  },
  activated() {
    this.getTableList();
  },
  mounted() {
    this.getFuncView();
  },
  methods: {
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    getTableList() {
      this.$getJSON(apis.workflowInfoPage, this.formSearch).then((res) => {
        this.tableList = res.data.records;
        this.totalRows = res.data.total;
      });
    },
    // 启用
    open(row) {
      this.$showConfirm(this.$t('base_approvalProcess.nqdyqyglc')).then(() => {
        this.$postJSON(`${apis.workflowInfoApproveEnableOrDisable}/${row.workflowId}`, {}, true).then(() => {
          this.$message({
            type: 'success',
            message: this.$t('Common.com_handle_success'),
          });
          this.getTableList();
        });
      });
    },
    // 禁用
    close(row) {
      this.$showConfirm(this.$t('base_approvalProcess.nqdyjyglc')).then(() => {
        this.$postJSON(`${apis.workflowInfoApproveEnableOrDisable}/${row.workflowId}`, {}, true).then(() => {
          this.$message({
            type: 'success',
            message: this.$t('Common.com_handle_success'),
          });
          this.getTableList();
        });
      });
    },
    // 编辑
    edit(row) {
      this.clearTagByKeep('processItem');
      this.jump('/redirect/examine/approvalProcess/editApprovalProcess', {
        workflowId: row.workflowId,
        parentPath: '/examine/approvalProcess',
      });
    },
    // 新增
    add() {
      this.clearTagByKeep('processItem');
      this.jump('/redirect/examine/approvalProcess/addApprovalProcess', { parentPath: '/examine/approvalProcess' });
    },
  },
};
</script>

<style lang="scss"></style>
